module.exports = __webpack_public_path__ + "img/SOSAnimation-v3.facb3bfc.gif";